export default {
  EoApplication: () => import('./EoApplication/EoApplication.vue'),
  EoAudioPlayer: () => import('./EoAudioPlayer/EoAudioPlayer.vue'),
  EoBreadcrumbs: () => import('./EoBreadcrumbs/EoBreadcrumbs.vue'),
  EoBroadcasters: () => import('./EoBroadcasters/EoBroadcasters.vue'),
  EoButton: () => import('./EoButton/EoButton.vue'),
  EoCallToAction: () => import('./EoCallToAction/EoCallToAction.vue'),
  EoCard: () => import('./EoCard/EoCard.vue'),
  EoCardCta: () => import('./EoCard/EoCardCta.vue'),
  EoCardPodcast: () => import('./EoCard/EoCardPodcast.vue'),
  EoCardProgram: () => import('./EoCard/EoCardProgram.vue'),
  EoCardPublication: () => import('./EoCard/EoCardPublication.vue'),
  EoCardTrack: () => import('./EoCard/EoCardTrack.vue'),
  EoCarousel: () => import('./EoCarousel/EoCarousel.vue'),
  EoCheckbox: () => import('./EoCheckboxGroup/EoCheckbox.vue'),
  EoCheckboxGroup: () => import('./EoCheckboxGroup/EoCheckboxGroup.vue'),
  EoColumn: () => import('./EoColumns/EoColumn.vue'),
  EoColumns: () => import('./EoColumns/EoColumns.vue'),
  EoContainer: () => import('./EoContainer/EoContainer.vue'),
  EoDatawrapper: () => import('./EoDatawrapper/EoDatawrapper.vue'),
  EoDonate: () => import('./EoDonate/EoDonate.vue'),
  EoDrawer: () => import('./EoDrawer/EoDrawer.vue'),
  EoFacebook: () => import('./EoFacebook/EoFacebook.vue'),
  EoFlockler: () => import('./EoFlockler/EoFlockler.vue'),
  EoFlocklerForm: () => import('./EoFlocklerForm/EoFlocklerForm.vue'),
  EoFrame: () => import('./EoFrame/EoFrame.vue'),
  EoFooter: () => import('./EoFooter/EoFooter.vue'),
  EoGiphy: () => import('./EoGiphy/EoGiphy.vue'),
  EoGrid: () => import('./EoGrid/EoGrid.vue'),
  EoHeader: () => import('./EoHeader/EoHeader.vue'),
  EoHero: () => import('./EoHero/EoHero.vue'),
  EoIcon: () => import('./EoIcon/EoIcon.vue'),
  EoImg: () => import('./EoImg/EoImg.vue'),
  EoInput: () => import('./EoInput/EoInput.vue'),
  EoInstagram: () => import('./EoInstagram/EoInstagram.vue'),
  EoList: () => import('./EoList/EoList.vue'),
  EoListItem: () => import('./EoList/EoListItem.vue'),
  EoLogo: () => import('./EoLogo/EoLogo.vue'),
  EoMain: () => import('./EoMain/EoMain.vue'),
  EoNav: () => import('./EoNav/EoNav.vue'),
  EoNewsletterSubscribe: () => import('./EoNewsletterSubscribe/EoNewsletterSubscribe.vue'),
  EoNpoPlayer: () => import('./EoNpoPlayer/EoNpoPlayer.vue'),
  EoNpoPlayer2: () => import('./EoNpoPlayer2/EoNpoPlayer2.vue'),
  EoPerson: () => import('./EoPerson/EoPerson.vue'),
  EoPicture: () => import('./EoPicture/EoPicture.vue'),
  EoPlaylist: () => import('./EoPlaylist/EoPlaylist.vue'),
  EoPoll: () => import('./EoPoll/EoPoll.vue'),
  EoPrefooter: () => import('./EoPrefooter/EoPrefooter.vue'),
  EoQualifio: () => import('./EoQualifio/EoQualifio.vue'),
  EoQuote: () => import('./EoQuote/EoQuote.vue'),
  EoRadio: () => import('./EoRadioGroup/EoRadio.vue'),
  EoRadioGroup: () => import('./EoRadioGroup/EoRadioGroup.vue'),
  EoRenderer: () => import('./EoRenderer/EoRenderer.vue'),
  EoSearch: () => import('./EoSearch/EoSearch.vue'),
  EoSlider: () => import('./EoSlider/EoSlider.vue'),
  EoSocialButton: () => import('./EoSocialButton/EoSocialButton.vue'),
  EoSoundcloud: () => import('./EoSoundcloud/EoSoundcloud.vue'),
  EoSpinner: () => import('./EoSpinner/EoSpinner.vue'),
  EoSpotify: () => import('./EoSpotify/EoSpotify.vue'),
  EoTab: () => import('./EoTabs/EoTab.vue'),
  EoTabs: () => import('./EoTabs/EoTabs.vue'),
  EoTextarea: () => import('./EoTextarea/EoTextarea.vue'),
  EoTiktok: () => import('./EoTiktok/EoTiktok.vue'),
  EoToggle: () => import('./EoCheckboxGroup/EoToggle.vue'),
  EoToolbar: () => import('./EoToolbar/EoToolbar.vue'),
  EoTooltip: () => import('./EoTooltip/EoTooltip.vue'),
  EoTransitionAccordion: () => import('./EoTransitionAccordion/EoTransitionAccordion.vue'),
  EoTransitionAccordionGroup: () =>
    import('./EoTransitionAccordion/EoTransitionAccordionGroup.vue'),
  EoTwitter: () => import('./EoTwitter/EoTwitter.vue'),
  EoTypeform: () => import('./EoTypeform/EoTypeform.vue'),
  EoVimeo: () => import('./EoVimeo/EoVimeo.vue'),
  EoYoutube: () => import('./EoYoutube/EoYoutube.vue'),
}
